<template lang="pug">
v-dialog(
  v-model="showing"
  max-width="320"
)
  template(v-slot:activator="{on}")
    v-switch(
      :input-value="value"
      readonly
      hide-details
      @click="showDialog"
      color="green"
    ).my-0.py-0
  v-card
    v-card-title.provide-title {{ title }}
    v-card-text {{ descr}}
    v-card-actions
      v-spacer
      v-btn(color="error" text @click="cancel") Cancel
      v-btn(color="success" text @click="submit" data-test="cm-provided-submit") Ok
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({
    title: '',
    descr: '',
    showing: false
  }),

  methods: {
    showDialog() {
      this.showing = true
      if(!this.value) this.setPositiveText()
      else this.setNegativeText()
    },

    setPositiveText() {
      this.title = 'Provide course'
      this.descr = 'Are you sure you want to change it? '
    },

    setNegativeText() {
      this.title = 'Provide course'
      this.descr = 'Are you sure you want to change it?'
    },

    hideShowing() {
      this.showing = false
    },

    cancel() {
      this.hideShowing()
      // this.$emit('input', this.value)
    },

    submit() {
      this.$emit('submit', !this.value)
    },


  }
}
</script>

<style lang="scss">
.provide-title {
  font-size: 24px !important;
}
</style>